var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module__edit_versions_table"},[_c('component-table',{attrs:{"labels":[
            {
                key: 'version',
                title: 'Version',
                type: 'string',
                sortable: true
            },
            {
                key: 'releasedBy',
                title: 'Released by',
                type: 'string',
                sortable: true
            },
            {
                key: 'releaseDate',
                title: 'Release date',
                type: 'date',
                sortable: true
            }
        ],"items":_vm.items,"component-table-item":_vm.ModuleEditVersionsTableItem,"component-table-collapse-item":_vm.ModuleEditVersionsTableItemCollapseTable,"component-table-collapse-item-active":_vm.activeCollapseIndex},on:{"emit-collapse":_vm.handleCollapse}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }